import { render, staticRenderFns } from "./card-list.vue?vue&type=template&id=38f83ea9&scoped=true&"
import script from "./card-list.vue?vue&type=script&lang=js&"
export * from "./card-list.vue?vue&type=script&lang=js&"
import style0 from "./card-list.vue?vue&type=style&index=0&id=38f83ea9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f83ea9",
  null
  
)

export default component.exports